import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getScreenWidth } from 'selectors/screen'
import { getMeasurementUnit } from 'selectors/user/session'
import {
  getArtworkCategory,
  getArtworkDescription,
  getArtworkKeywords,
  getArtworkMaterials,
  getArtworkMediums,
  getArtworkStyles,
  getArtworkSubject,
  getArtworkYearProduced,
  getArtworkDimensions,
  getArtworkMultiPanel,
  getArtworkId,
  getArtworkHasLimitedEditions,
  getArtworkTitle,
  getArtworkPanels,
} from '../selectors/artwork'
import {
  SelectedCanvasWrapColorOption,
  SelectedFrameOption,
  getCurrentTab,
  getOriginalProductPackagingOption,
  getOriginalProductReadyToHangStatus,
  getOriginalProductFrameStatus,
  getOriginalProductFrameColor,
  getSelectedCanvasWrapColorOption,
  getSelectedFrameOption,
  getSelectedProduct,
  getOriginalProductIsAple,
  getOriginalProductUnitsProduced,
  getOriginalProductListPrice,
  getOriginalProductShipsFromCountry,
  getCurrentProductType,
  getOriginalProductIsOutdoor,
} from '../selectors/product'
import { getArtistCountry, getArtistName } from '../selectors/artist'
import { ArtworkDimensions } from '../types'

const mapStateToProps = createStructuredSelector({
  artistCountry: getArtistCountry,
  artistName: getArtistName,
  artworkTitle: getArtworkTitle,
  artworkID: getArtworkId,
  category: getArtworkCategory,
  currentTab: getCurrentTab,
  description: getArtworkDescription,
  dimensions: getArtworkDimensions,
  frameColor: getOriginalProductFrameColor,
  frameStatus: getOriginalProductFrameStatus,
  isAple: getOriginalProductIsAple,
  isLimitedEdition: getArtworkHasLimitedEditions,
  isMultiPanel: getArtworkMultiPanel,
  isOutdoor: getOriginalProductIsOutdoor,
  readyToHangStatus: getOriginalProductReadyToHangStatus,
  keywords: getArtworkKeywords,
  materials: getArtworkMaterials,
  mediums: getArtworkMediums,
  originalProductPrice: getOriginalProductListPrice,
  packingOption: getOriginalProductPackagingOption,
  panels: getArtworkPanels,
  productType: getCurrentProductType,
  screenWidth: getScreenWidth,
  selectedPrintProduct: getSelectedProduct,
  selectedFrameOption: getSelectedFrameOption,
  selectedCanvasWrapColorOption: getSelectedCanvasWrapColorOption,
  shipsFromCountry: getOriginalProductShipsFromCountry,
  styles: getArtworkStyles,
  subject: getArtworkSubject,
  unitsProduced: getOriginalProductUnitsProduced,
  userSizePreference: getMeasurementUnit,
  yearProduced: getArtworkYearProduced,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  artistCountry: string
  artistName: string
  artworkID: string
  artworkTitle: string
  category: string
  currentTab: string
  description: string
  dimensions: ArtworkDimensions
  frameColor: string
  frameStatus: string
  isAple: boolean
  isLimitedEdition: boolean
  isMultiPanel: boolean
  isOutdoor: boolean
  readyToHangStatus: string
  keywords: ReadonlyArray<string>
  materials: ReadonlyArray<string>
  mediums: ReadonlyArray<string>
  originalProductPrice: number
  packingOption: string
  panels: number
  productType: string
  screenWidth: number
  selectedPrintProduct: Record<string, any>
  selectedFrameOption: SelectedFrameOption
  selectedCanvasWrapColorOption: SelectedCanvasWrapColorOption
  shipsFromCountry: string
  styles: ReadonlyArray<string>
  subject: string
  unitsProduced: number
  userSizePreference: string
  yearProduced: number
}
export default connect(mapStateToProps, mapDispatchToProps)
